import { form } from '../formState'
import { useTexts } from '../../hooks/useTexts'

export function OverrideSenderName() {
  const texts = useTexts()

  return (
    <form.Checkbox
      label={texts.overrideSenderName}
      validateOn="change"
      name="overrideSenderName"
      testId="overrideSenderName"
    />
  )
}
